import React from 'react'
import env from '@maui-mf/env'
import { AUTH_REDIRECT_PATH } from '@maui-mf/common-auth'
import { AuthProvider as BaseProvider } from '@maui-mf/common-react'

const defaultProps = {
  clientId: env.MAUI_IDP_CLIENT_ID,
  host: env.MAUI_IDP_HOST,
  redirectUri: new URL(AUTH_REDIRECT_PATH, env.MAUI_HOST).toString(),
}

export const AuthProvider = props => (
  <BaseProvider {...defaultProps} {...props} />
)
